import React from 'react'
import styled from 'styled-components'
import Box, {BoxProps} from '@fuegokit/react/components/Box'
import themeGet from '@fuegokit/react/utils/theme-get'
import sx, {SxProp} from '@fuegokit/react/sx'
import {Appearance} from './AtlasButton'

export type AtlasButtonGroupProps = {
  /**
   * The appearance to apply to all Buttons
   */
  appearance?: Appearance
  /**
   * elements to render
   */
  children?: React.ReactNode
}

const Wrapper = styled(Box)<BoxProps & SxProp>`
  display: inline-flex;
  gap: ${themeGet('space.1')};
  & > * {
    flex: 1 0 auto;
  }
  ${sx}
`

export const AtlasButtonGroup = ({appearance, children, ...props}: AtlasButtonGroupProps & SxProp) => {
  return (
    <Wrapper {...props}>
      {/* flatten children to apply correct styles in the case where a child is an array of elements */}
      {React.Children.map(React.Children.toArray(children), (child, idx) => {
        if (!child) {
          return null
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={idx}>
            {appearance ? React.cloneElement(child as JSX.Element, {appearance}) : child}
          </React.Fragment>
        )
      })}
    </Wrapper>
  )
}

AtlasButtonGroup.displayName = 'AtlasButtonGroup'
